import { FC } from 'react';
import { useTranslation } from 'react-i18next';
// import PolylineIcon from '@mui/icons-material/Polyline';
import { IEntityContentField } from '../../../lib/interfaces/Common';
import {
	getContentFieldValue,
	CONTENT_FIELDS,
} from '../../../lib/helpers/content.helper';
import { ApiControlContent, Section } from '../../../lib/interfaces/ApiControl';
import ApiControlSection from './ApiControlSection';
import { replaceGlobalVariablesSimplified } from './apiControl.utils';
// import ContentTitleWithIcon from '../../Simple/ContentTitle/ContentTitleWithIcon';
// import ContentRenderer from '../Content/ContentRenderer';

type ApiControlProps = {
	field: IEntityContentField;
};

const ApiControl: FC<ApiControlProps> = ({ field }) => {
	// console.log('ApiControl: ', field);
	const { reference, options } = field;
	const { i18n } = useTranslation();
	const currentLanguage: string = i18n.language;
	// const title =
	// 	reference?.content &&
	// 	getContentFieldValue({
	// 		entityContent: reference.content,
	// 		field: CONTENT_FIELDS.NAME,
	// 		language: currentLanguage,
	// 	});
	// const content =
	// 	reference?.content &&
	// 	getContentFieldValue({
	// 		entityContent: reference.content,
	// 		field: CONTENT_FIELDS.CONTENT,
	// 		language: currentLanguage,
	// 	});

	const apis: ApiControlContent | undefined =
		reference?.content &&
		(getContentFieldValue({
			entityContent: reference.content,
			field: CONTENT_FIELDS.APIS,
			language: currentLanguage,
			property: 'options',
		}) as ApiControlContent);

	const apisParsedSections: Section[] = apis?.sections
		? replaceGlobalVariablesSimplified(apis.sections, apis?.globalVariables)
		: apis?.sections;
	let apisFilteredSections = apisParsedSections;
	if (options?.apiControlSelections?.level === 'api') {
		const apiId = options.apiControlSelections.id;
		apisFilteredSections = apisParsedSections.filter((section) => {
			const search = section.apiItems.find((item) => item.id === apiId);
			if (search) {
				return search;
			}
		});
		if (apisFilteredSections?.[0]?.apiItems) {
			apisFilteredSections[0].apiItems = apisFilteredSections[0].apiItems.filter(
				(item) => item.id === apiId,
			);
		}
	}

	return (
		<div>
			{/* <ContentTitleWithIcon
				id={field.id}
				content={title || t('apiControl')}
				icon={PolylineIcon}
			/>
			<ContentRenderer html={content} key="desc" /> */}
			{apisFilteredSections && (
				<div>
					{apisFilteredSections.map((section: Section) => (
						<ApiControlSection
							section={section}
							mode={options?.apiControlSelections?.level}
						/>
					))}
				</div>
			)}
		</div>
	);
};

export default ApiControl;

/**
{
    "name": "apis_en",
    "type": "apiControlBlock",
    "label": "APIs",
    "content": "",
    "options": {
        "sections": [
            {
                "id": "51b9381a-f8f9-4105-978d-ff550d51a676",
                "title": "Authentication",
                "apiItems": [
                    {
                        "id": "4cc2188a-d840-4842-a904-dcd00b7ac8ce",
                        "type": "REST",
                        "title": "User Registration",
                        "method": "post",
                        "headers": [],
                        "endpoint": "CW_BASE_URL/api/auth/register",
                        "examples": [],
                        "urlParams": [],
                        "bodyParams": [],
                        "description": "<p>API to create new User in your application</p>"
                    }
                ],
                "description": "<p>I</p>"
            },
            {
                "id": "29f123d8-80c6-4d9c-b080-a8e74f9ba133",
                "title": "Posts",
                "apiItems": [
                    {
                        "id": "e4833822-3f0c-4289-9b79-920bebc6c56d",
                        "type": "REST",
                        "title": "Get posts",
                        "method": "get",
                        "headers": [],
                        "endpoint": "/posts/",
                        "examples": [],
                        "urlParams": [],
                        "bodyParams": [],
                        "description": ""
                    },
                    {
                        "id": "f7e3886c-410e-4cea-9840-ae9ff8d2da66",
                        "type": "REST",
                        "title": "Create post",
                        "method": "post",
                        "headers": [
                            {
                                "id": "edd718db-76e7-46a7-83e0-b09d62742bbd",
                                "name": "cw-token",
                                "type": "string",
                                "example": "{\"cw-token\": \"wryytuysdfsfsf...sdfsdfsdf\"}",
                                "required": true,
                                "description": "Codeway.TODAY token"
                            }
                        ],
                        "endpoint": "/posts/:id",
                        "examples": [
                            {
                                "id": "82eaec88-3878-4aca-bca4-f11eb9e3d0a2",
                                "title": "Success request",
                                "description": "<pre><code class=\"language-javascript\">{\n
								 \"name\": \"Hello\",\n  \"description\": \"Yo yo yo!\"\n}</code></pre>"
                            },
                            {
                                "id": "7bf9b5ad-0a01-46c2-9e59-4074c7ba502f",
                                "title": "Success reponse",
                                "description": "<pre><code class=\"language-javascrip
								t\">{\n  \"id\": 2,\n  \"name\": \"Hello\",\n  \"descr
								iption\": \"Yo yo yo!\"\n}</code></pre>"
                            }
                        ],
                        "urlParams": [
                            {
                                "id": "da40c74f-7a9e-472b-b23a-44e88fed1a60",
                                "name": "id",
                                "type": "",
                                "example": "/posts/1",
                                "required": true,
                                "description": "post id"
                            }
                        ],
                        "bodyParams": [
                            {
                                "id": "95dd8bd5-79d8-4151-a4c5-bbc67611b6a0",
                                "name": "name",
                                "type": "string",
                                "example": "{\"name\": \"Yo man\"}",
                                "required": true,
                                "description": "Post title"
                            },
                            {
                                "id": "04083d55-85db-4a94-8440-8a7a278a514b",
                                "name": "description",
                                "type": "string",
                                "example": "{\"description\": \"Hello yo!\"}",
                                "required": true,
                                "description": "Post text"
                            }
                        ],
                        "description": ""
                    }
                ],
                "description": ""
            }
        ],
        "globalVariables": {
            "CW_BASE_URL": "https://redapp.codeway.today"
        }
    }
}
 */
